if (!customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeVideoPlayer();
    }

    initializeVideoPlayer() {
      const video = this.querySelector('video');
      video.querySelector('img')?.setAttribute('alt', 'video player poster image.');

      video.addEventListener('ended', () => {
        this.setAttribute('data-state', 'ended');
      });

      this.addEventListener('click', ({ target }) => {
        const actionElement = target.closest('[data-action]');
        if (!actionElement) return;

        const { action } = actionElement.dataset;
        switch (action) {
          case 'play':
            video.play();
            this.setAttribute('data-state', 'playing');
            break;
          case 'pause':
            video.pause();
            this.setAttribute('data-state', 'paused');
            break;
          case 'mute':
            video.muted = true;
            this.setAttribute('data-muted', 'muted');
            break;
          case 'unmute':
            video.muted = false;
            this.setAttribute('data-muted', 'unmuted');
            break;
        }
      });
    }
  }

  const defineVideoPlayer = () => {
    if (!customElements.get('video-player')) {
      customElements.define('video-player', VideoPlayer);
    }
  };

  defineVideoPlayer();

  new MutationObserver((mutations) => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'VIDEO-PLAYER') {
          defineVideoPlayer();
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}